import { useLayoutEffect } from "react";

/**
 * Prevents background scroll and layout shift when drawer is open.
 * Restores body styles when the drawer is closed or on unmount.
 */
export const useDrawerScrollLock = (isDrawerOpen: boolean) => {
  useLayoutEffect(() => {
    if (isDrawerOpen) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [isDrawerOpen]);
};
